import { useMemo, useState } from "react";
import { useSavedViews } from "./SavedViewsContext";
import SavedViewNameModal from "./SavedViewNameModal";

function mergeWithDefaults(defaultView, savedView) {
  return {
    ...defaultView,
    ...savedView,
    filters: { ...(defaultView.filters || {}), ...(savedView.filters || {}) },
    sort: { ...(defaultView.sort || {}), ...(savedView.sort || {}) },
    settings: { ...(defaultView.settings || {}), ...(savedView.settings || {}) },
  };
}

export default function SavedViewsControls({ sectionId, currentView, defaultView, onApply }) {
  const { views, createView, updateView, removeView } = useSavedViews();
  const [selectedId, setSelectedId] = useState("default");
  const [isNameOpen, setIsNameOpen] = useState(false);
  const sectionViews = useMemo(() => views.filter((view) => view.sectionId === sectionId), [sectionId, views]);
  const selectedView = sectionViews.find((view) => view.id === selectedId) || null;
  const controlStyle = { padding: "7px 9px", borderRadius: "8px", border: "1px solid var(--border-strong)", background: "var(--card-bg-soft)", color: "var(--text-main)", fontSize: "12px", fontWeight: 700 };
  const applyId = (id) => {
    setSelectedId(id);
    const view = sectionViews.find((item) => item.id === id);
    onApply(view ? mergeWithDefaults(defaultView, view) : defaultView);
  };
  return <>
    <div style={{ display: "flex", alignItems: "center", gap: "7px", flexWrap: "wrap", marginBottom: "9px" }}>
      <select value={selectedId} onChange={(event) => applyId(event.target.value)} style={controlStyle}><option value="default">По умолчанию</option>{sectionViews.map((view) => <option key={view.id} value={view.id}>{view.name}</option>)}</select>
      <button type="button" style={controlStyle} onClick={() => setIsNameOpen(true)}>Сохранить текущий вид</button>
      <button type="button" style={controlStyle} disabled={!selectedView} onClick={() => updateView(selectedView.id, currentView)}>Обновить представление</button>
      <button type="button" style={controlStyle} disabled={!selectedView} onClick={() => { if (selectedView) { removeView(selectedView.id); applyId("default"); } }}>Удалить</button>
    </div>
    <SavedViewNameModal isOpen={isNameOpen} onClose={() => setIsNameOpen(false)} onSave={(name) => { const view = createView(sectionId, name, currentView); if (view) setSelectedId(view.id); setIsNameOpen(false); }} />
  </>;
}
